module.exports = __webpack_public_path__ + "117a5e4162a30de5b7ca72a6a4bf6c33.MP3";